import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { AuthProvider } from "./utils/authContext";
import { Provider } from 'react-redux';
import { store } from '../src/utils/store';
import LogoUrlRestorer from "./components/LogoUrlRestorer";
import { GoogleOAuthProvider } from '@react-oauth/google';

// Create a client instance
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Provider store={store}>
          <LogoUrlRestorer />
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <App />
          </GoogleOAuthProvider>
        </Provider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
